var path = 'areas/projects/triggers/trigger_create.html';
var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href='#/projects/{{ project.Slug }}/triggers/create'>Create New</a></li> </script> <project-trigger-editor></project-trigger-editor> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/triggers/trigger_create.html
// module id = 7562465929998513
// module chunks = 1